import React from "react";

export function Spacer({ size = 1 }) {
  return <div style={{ margin: `${size * 0.5}rem 0` }} />;
}
